import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useParams, useNavigate, useSearch, Outlet } from '@tanstack/react-router';

import { useContractsQueries } from '../../lib/queries/contracts';

import { Sidebar } from './components/sidebar';
import ErrorPage from './page.error';
import { ContractDetailsPageSkeleton } from './page.skeleton';

import { FullMainHeight } from '@ui';

export function ContractDetailsPage() {
  const { contractId } = useParams({
    from: '/_app/os/contracts_/$contractId',
  });
  const navigate = useNavigate();
  const { campaign } = useSearch({
    from: '/_app/os/contracts_/$contractId',
  });

  const selectedCampaignIds = campaign || [];

  const contractsQueries = useContractsQueries();
  const { data, isLoading } = useQuery({
    ...contractsQueries.detail(
      Number(contractId),
      selectedCampaignIds.length > 0 ? selectedCampaignIds : undefined,
    ),
    placeholderData: keepPreviousData,
  });

  const handleCampaignIdsChange = (campaignIds: number[]) => {
    // Casting is used here because the router's inferred search schema is too
    // narrow for our enriched search object, even though this shape is valid
    // at runtime for our route definition.
    (navigate as any)({
      search: (prev: any) => ({
        ...prev,
        campaign: campaignIds.length > 0 ? campaignIds : undefined,
      }),
      replace: true,
    });
  };

  if (isLoading && !data) {
    return <ContractDetailsPageSkeleton />;
  }

  if (!data) {
    return null;
  }

  return (
    <FullMainHeight.Root>
      <FullMainHeight.FlexContent>
        <FullMainHeight.Sidebar>
          <Sidebar
            contract={data}
            contractId={contractId}
            onCampaignIdsChange={handleCampaignIdsChange}
            selectedCampaignIds={selectedCampaignIds}
          />
        </FullMainHeight.Sidebar>
        <Outlet />
      </FullMainHeight.FlexContent>
    </FullMainHeight.Root>
  );
}

ContractDetailsPage.Skeleton = ContractDetailsPageSkeleton;
ContractDetailsPage.Error = ErrorPage;
